module.exports = __webpack_public_path__ + "static/img/italy.cc79b18.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/italy.png
// module id = x+ZS
// module chunks = 1